export const shoeAnimationTimeline = ({ timeline, shoeRef }) => {
    timeline.add({
        targets: shoeRef.current,
        opacity: 1,
        duration: 500,
        easing: 'easeInOutSine',
    });
};
